<template lang="pug">
#page_video.page
	Banner(v-bind:item='item_landing', classes='item_video')
	.container: .row.justify-content-center: .col-sm-10
		#gallery
			swiper.top(
				v-bind:effect='"fade"',
				v-bind:navigation='true',
				v-bind:loop='false',
				v-bind:spaceBetween='10',
				v-bind:thumbs='{ swiper: thumbsSwiper }'
			)
				swiper-slide(v-if='item.link_yt !== ""')
					iframe(
						v-bind:src='item.link_yt !== "" ? item.link_yt : ""',
						frameborder='0',
						allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
						allowfullscreen=''
					)
				//- Eric_20220302:
				//- Show all photos 
				template(v-if='item.photo.length')
					template(v-for='photo in item.photo')
						swiper-slide
							img(
								v-bind:src='require(`@/assets/images/film_photo/program/${item.id}/${photo}`)'
							)
			template(v-if='item.image !== ""')
				swiper.bottom(
					v-on:swiper='setThumbsSwiper',
					v-bind:loop='false',
					v-bind:spaceBetween='10',
					v-bind:slidesPerView='6',
					v-bind:freeMode='true',
					v-bind:watchSlidesProgress='true'
				)
					swiper-slide(v-if='item.link_yt !== ""')
						img(
							v-bind:src='require(`@/assets/images/film_photo/program/${item.id}/${item.photo.slice(0, 1)}`)'
						)
						font-awesome-icon(
							v-if='item.link_yt',
							v-bind:icon='["fas", "play-circle"]'
						)
					template(v-if='item.photo.length')
						template(v-for='photo in item.photo')
							swiper-slide
								img(
									v-bind:src='require(`@/assets/images/film_photo/program/${item.id}/${photo}`)'
								)
		#intro
			.content
				.title_wrapper
					h2.title {{ item.title }}
					h4.title_en {{ item.title_en }}
				.info
					.stuff {{ item.stuff }}
					.year_and_country {{ item.year }} {{ item.country }}
					.type {{ item.type[0] }} | {{ item.film_length }}{{ $t('general_minute') }} | {{ item.rated }}
			.list_badge
				.badge(v-for='badge in item.badges') {{ badge }}
			template(v-if='item.award && item.award.split(",").length')
				hr
				.award_list
					h4.award(v-for='award in item.award.split(",")') {{ award }}
			h4.desc_video(v-html='item.desc')

			.view_online
				.button_action.icon
					.wrapper
						a(
							v-if='item.link_ptsplus != ""',
							v-bind:href='item.link_ptsplus',
							target='_blank'
						)
							.text {{ $t('video_item_watch_now') }}
							img(src='@/assets/images/icon_play.png')
				h5.time(v-if='item.online && item.link_ptsplus != ""') {{ $t('video_item_date') }}：{{ item.online }}
		CardJudge.special_judge(v-if='id === "special"', v-bind:item='item_judge')
</template>

<script>
import Banner from '@/components/Banner.vue';
import CardJudge from '@/components/CardJudge.vue';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import SwiperCore, { EffectFade, FreeMode, Navigation, Thumbs } from 'swiper';
import 'swiper/swiper-bundle.css';
SwiperCore.use([EffectFade, FreeMode, Navigation, Thumbs]);

export default {
	data() {
		return {
			id: '',
			item: {},
			item_judge: {
				name: '張吾青 WU-CHING CHANG',
				image: 'assets/images/film_photo/program/special/judge.jpeg',
				desc: '張吾青出生於臺灣臺北，為動畫導演、概念美術設計師與插畫家，艾可創意公司創辦人。英國皇家藝術學院動畫碩士，臺北藝術大學新媒體藝術學士。自 2014 年起創作動畫短片，除了商業與獨立動畫外，也跨足插畫與遊戲美術領域。合作客戶包括公共電視與 Tiger Party 等，同時她也是遊戲《最終幻想十五代口袋版》的美術設計與過場動畫設計師。</br></br>動畫影像作品經常以探討個人經驗與女性議題為出發點，於前期製作階段進行訪談，創作奠基於文化脈絡，並常以手繪質感為基調，使用各種實驗性媒材，透過影像訴說生命的故事。</br></br>她的動畫短片展映於國際影展，動畫作品《我的阿婆是一顆蛋》(2021) 獲得台灣國際女性影展評審團特別提及獎，入圍於澳洲Flickerfest短片影展、加拿大Hot Docs國際紀錄片影展、英國Encounters影展等，並受邀於奧地利電子藝術節參展。動畫作品《鳥》(2019)獲得美國棕梠泉動畫節手繪動畫獎、土耳其哈利卡那索斯影展最佳動畫短片獎，並入圍美國Flickers羅德島國際影展、英國諾里奇影展、印度邦加羅爾影展等。實驗影像作品《無常之海》(2019)獲得印度國際影展最佳多媒體獎，動畫作品《母親》(2014)獲得K.T.科藝獎動畫組優選獎、4C數位科技創作競賽動畫組最佳視覺效果獎。',
				desc_en: `
					Born in Taiwan, Wu-Ching Chang is an animation director, illustrator, and concept artist who earned MA. Animation at Royal College of Art in the UK and BFA in New Media Art at the Taipei National University of the Arts in Taiwan. She is the founder of Aco Creative Ltd. She has worked on commercial and independent animation, illustration, and game concept arts since 2014. The clients include Channel Four and Tiger Party New York. She had worked as the concept artist and cinematic artist for the game Final Fantasy XV Pocket Edition.</br></br>
					She creates animated short films by exploring personal experiences and female issues. Her films are often based on cultural context by doing interviews and research in the pre-production stage. Except for 2D animation with hand-painted texture, her films contain multiple experimental practices, such as animating with eggs. Through visual art, she tells stories about life.</br></br>
					Her animated short films were screened at festivals around the world and her animated short film ' My Grandmother Is an Egg' won the Jury Special Mention Award at Women Make Waves Film Festival and is officially selected at Flickerfest International Short Film Festival, Hot Docs Canadian International Documentary Festival, Encounters Short Film and Animation Festival, and was exhibited at Ars Electronica. Her animated short film 'Bird' won Hand-Painted Animated Shorts Award at Palm Springs Int. Animation Festival and Best Animation Short Award at Halicarnassus Film Festival. ‘Bird’ is officially selected at Norwich Film Festival, St. Louis International Film Festival, and Bengaluru International Short Film Festival. Her experimental short film ’The Impermanent Sea’ won Best Multimedia Film Award at Global India International Film Festival. Her animated short film 'Mother' won Quality Award at T. Creativity Award and Best Visual Effects Award at 4C Digital Content Awards.
				`,
			},
			items: [],
			thumbsSwiper: null,
		};
	},
	methods: {
		setThumbsSwiper: function (swiper) {
			this.thumbsSwiper = swiper;
		},
		refresh: function () {
			this.id = this.$route.params.id;
			let video_data = require(`@/assets/data/video_${this.$i18n.locale}`);
			this.items = [...video_data];
			let temp = this.items.filter(item => item.id == this.id);
			if (temp.length) {
				temp = temp[0];
				temp.badges = [
					temp.category,
					temp.region,
					temp.rated,
					...temp.type,
				];
				this.item = {
					...temp,
					title: temp.title_tw,
				};
			} else {
				this.$router.push({ name: 'Index' });
			}
		},
	},
	computed: {
		item_landing: function () {
			let image_path =
				this.item.image !== ''
					? `assets/images/film_photo/program/${this.item.id}/${this.item.image}`
					: 'assets/images/demo.jpg';
			return {
				...this.item,
				category: this.item.category,
				media: image_path,
			};
		},
	},
	watch: {
		'$i18n.locale'() {
			this.refresh();
		},
		$route() {
			this.refresh();
		},
	},
	created() {
		this.refresh();
	},
	components: {
		Banner,
		CardJudge,
		Swiper,
		SwiperSlide,
	},
};
</script>

<style lang="stylus">
#page_video
	#gallery
		width: 100%
		height: 600px
		margin-bottom: 36px
		.swiper
			width: 100%
			height: 100%
			&.top
				width: 100%
				height: 85%
				.swiper-slide
					border-radius: 15px
					overflow: hidden
			&.bottom
				width: 75%
				height: 15%
				margin-left: unset
				padding: 10px 0
				.swiper-slide
					position: relative
					opacity: 0.5
					cursor: pointer
					img
						border-radius: 5px
					svg
						position: absolute
						width: 50%
						height: 50%
						color: white
						left: 50%
						top: 50%
						transform: translate(-50%, -50%)
					&.swiper-slide-thumb-active
						opacity: 1
					&:hover
						opacity: 1
			.swiper-slide
				display: flex
				justify-content: center
				align-items: center
				img, iframe
					display: block
					width: 100%
					height: 100%
					object-fit: cover
					object-position: center center
	#intro
		color: white
		margin-bottom: 38px
		border-radius: 15px
		padding: 2rem
		// background-color: $color_dark
		.content
			display: flex
			justify-content: space-between
			flex-wrap: wrap
			.title_wrapper
				display: flex
				flex-direction: column
				align-items: flex-start
				.title, .title_en
					color: white
				.title
					line-height: 24px
					margin-bottom: 0.5rem
				.title_en
					line-height: 22px
					margin-bottom: 0
			.info
				display: flex
				flex-direction: column
				align-items: flex-end
				font-size: $fs-4
				.stuff
					margin-bottom: 2rem
		.award_list
			margin-top: 1rem
			.award
				text-align: left
	.desc_video
		padding-top: 40px
		color: white
		line-height: 2rem
		text-align: justify
	.view_online
		display: flex
		flex-direction: column
		align-items: center
		margin-top: 5rem
		.time
			margin-top: 8px
			color: white
	@media screen and (max-width: $screen-sm-max)
		#gallery
			height: 300px
		#intro
			.content
				.title_wrapper
					flex-basis: 100%
				.info
					align-items: flex-start
		.desc_video
			padding: 0 0.5rem
</style>
